/**
 * Helpers partagés — thème DIVISIBILITÉ 3ème (attendus 205-207, d10 O5-O7).
 *
 * Arithmétique entière exacte : décomposition en facteurs premiers par
 * divisions successives, PGCD/PPCM, affichage canonique en KaTeX. Dans les
 * trous, bases et exposants sont des trous SÉPARÉS — un exposant ne se tape
 * jamais au clavier.
 */

export const PREMIERS = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97];

export const estPremier = (n) => {
    if (!Number.isInteger(n) || n < 2) return false;
    for (let d = 2; d * d <= n; d++) if (n % d === 0) return false;
    return true;
};

/** Décomposition { facteur: exposant } par divisions successives. */
export const decomposer = (n) => {
    const out = {};
    let x = n;
    for (let d = 2; d * d <= x; d++) {
        while (x % d === 0) { out[d] = (out[d] || 0) + 1; x /= d; }
    }
    if (x > 1) out[x] = (out[x] || 0) + 1;
    return out;
};

/** Recompose une décomposition { p: e } en entier. */
export const recomposer = (dec) =>
    Object.entries(dec).reduce((acc, [p, e]) => acc * Number(p) ** e, 1);

/** Fusionne deux décompositions (addition des exposants). */
export const fusionner = (a, b) => {
    const out = { ...a };
    for (const [p, e] of Object.entries(b)) out[p] = (out[p] || 0) + e;
    return out;
};

/**
 * Fragment LaTeX canonique d'une décomposition : « 2^{2} \times 3 \times 17 »
 * (bases croissantes, exposant omis quand il vaut 1). SANS les `$` : à emballer
 * par `tex()` ou à insérer dans une expression plus large.
 */
export const decompFrag = (dec) =>
    Object.keys(dec).map(Number).sort((a, b) => a - b)
        .map(p => (dec[p] >= 2 ? `${p}^{${dec[p]}}` : String(p)))
        .join(' \\times ');

export const pgcd = (a, b) => { a = Math.abs(a); b = Math.abs(b); while (b) { [a, b] = [b, a % b]; } return a || 1; };
export const ppcm = (a, b) => a * b / pgcd(a, b);
